import React from 'react'
import { Body2 } from '../../MaterialUi/Typo'
import { useStyle } from './Style'
import { InstructionProps } from './Type'

export const Instruction: React.FC<InstructionProps> = ({ asset }): React.ReactElement => {
  const classes = useStyle()

  return (
    <div data-testid="instruction">
      {asset && asset?.instructions && (
        <div className={classes.instructionsWrapper}>
          <div className={classes.instructionsInner}>
            <div className={classes.instructions}>
              <div className={classes.sideBorder} />
              <Body2 className={classes.instructionsBody}>{asset?.instructions}</Body2>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Instruction
